module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"status":{"to_do":"To do","overdue":"Overdue","completed":"Completed","archived":"Archived","due_soon":"Due soon"}}}')
  delete Component.options._Ctor
}
